import { Button, Modal, Result } from 'antd';
import React from 'react';
import { ROUTES } from '../../../common/constants';
import useRouter from '../../../hooks/useRouter';
import '../styles/annotationFailModal.less';

type Props = {
  visible: boolean;
  onClose: () => void;
};

const AnnotationFailModal: React.FC<Props> = ({ visible, onClose }) => {
  const { navigate } = useRouter();

  const handleRedirect = () => {
    onClose();
    navigate(ROUTES.MAIN);
  };

  return (
    <Modal
      open={visible}
      footer={null}
      onCancel={onClose}
      centered
      destroyOnClose
    >
      <Result
        className="annotation-failed"
        status="error"
        title="Annotation Update Failed"
        subTitle="Something went wrong during the annotation submission. Please reupload the floor plan and try again."
        extra={[
          <Button
            className="annotation-failed-modal-btn "
            type="primary"
            onClick={handleRedirect}
            key="home"
          >
            Go to Home & Re-upload
          </Button>,
        ]}
      />
    </Modal>
  );
};

export default AnnotationFailModal;
